import { Component, OnInit, Input, Output, EventEmitter, Self, Optional, ElementRef, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl, Validators } from '@angular/forms';


@Component({
  selector: 'dao-textbox',
  templateUrl: './dao-texbox.component.html',
  styleUrls: ['./dao-texbox.component.css']
})
export class DaoTexboxComponent implements ControlValueAccessor, OnInit {

  @Input('label') label: string;
  @Input('value') value: string;
  @Input('maxlength') maxlength: number;
  @Input('minlength') minlength: number;
  @Input('max') max: number;
  @Input('min') min: number;
  @Input('required') required: boolean;
  // @Input('Mandatory') Mandatory:boolean;
  @Input('disabled') disabled: boolean;
  @Input('type') type: string;
  @Input('showAdd') showAdd: boolean = false;
  @Input('showDelete') showDelete: boolean = false;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() onAdd: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();




  @ViewChild('input') input: ElementRef;

  public pattern: any = null;

  private errorMessages = new Map<string, () => string>();
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
    this.errorMessages.set('required', () => `${this.label} is required.`);
    this.errorMessages.set('pattern', () => `${this.label} is invalid.`);
    this.errorMessages.set('minlength', () => `The no. of characters should not be less than ${this.minlength}.`);
  }
  ngOnInit(): void {
    this.setFieldType();
    this.setValidators();
  }

  private setFieldType() {
    if (this.type) {
      if (this.type.toLowerCase() == 'email') {
        this.pattern = new RegExp("^[a-z0-9](\.?[a-z0-9_-]){0,}@[a-z0-9-]+\.([a-z]{1,6}\.)?[a-z]{2,6}$");
      }
      else if (this.type.toLowerCase() == 'phone') {
        this.pattern = new RegExp('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$', 'im');
        this.minlength = 9;
      }
      else if (this.type.toLowerCase() == 'amount') {
        this.pattern = new RegExp('^[0-9]+(\,+[0-9]+)*(\.[0-9]{1,3})?$');
      }
      else if (this.type.toLowerCase() == 'name'){
        this.pattern = new RegExp("^[a-zA-Z'. ]+$");
      }
      else if (this.type.toLowerCase() == 'number'){
        this.pattern = new RegExp("^[0-9]+$");
      }
      else if (this.type.toLowerCase() == 'cnic'){
        this.pattern = new RegExp("^[0-9]+$");
        this.minlength=13;
        this.maxlength = 13;
      }
      else if (this.type.toLowerCase() == 'percentage'){
        this.pattern = new RegExp("^[1-9][0-9]?$");
        if(this.min === 15){ //hard coded case for samba non lien
          this.pattern = new RegExp("^(1[5-9]|[2-9][0-9]|[1-9])$");
        }
        
        
      }
      else if (this.type.toLowerCase() == 'percentage15'){
        this.pattern = new RegExp("^(1[5-9]|[2-9][0-9]|[1-9])$");
      }
    }
  }
  private setValidators() {
    let validators = [];
    if (this.minlength) validators.push(Validators.minLength(this.minlength));
    if (this.maxlength) validators.push(Validators.maxLength(this.maxlength));
    if (this.required) validators.push(Validators.required);
    if (this.pattern) validators.push(Validators.pattern(this.pattern));
    if (this.control) {
      this.control.control.setValidators(validators);
    }
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? (dirty || touched) : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key);
  }

  public onChangeFn = (_: any) => { };

  public onTouchedFn = () => { };

  public registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  public writeValue(obj: any): void {
    this.value = obj;
  }

  public onChange() {
    // this.decideValidity();
    this.onChangeFn(this.value);
    this.valueChange.emit(this.value);
  }

  public addClick(event: Event) {
    event.stopPropagation();
    this.onAdd.emit(event);
  }

  public deleteClick(event: Event) {
    event.stopPropagation();
    this.onDelete.emit(event);
  }

  // private decideValidity(){
  //   let nativeInputElement = this.input.nativeElement;
  //   if(nativeInputElement.validity.valid == false){
  //     if(this.control.validator.)
  //     this.control.errors["pattern"] = true;
  //   }
  // }


}
